module.exports = __webpack_public_path__ + "img/16_11.0f7dc552.png";